import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { WHATSAPP_FLOW_OPTIONS, WhatsappFlowOption } from '@core/constants/whatsapp-flows';
import { EventLogItem } from '@core/interfaces/event-log.interface';
import { EventsService } from '@core/services/events/events.service';

@Component({
  selector: 'app-list-flows-history',
  templateUrl: './list-flows-history.component.html',
  styleUrls: ['./list-flows-history.component.scss'],
})
export class ListFlowsHistoryComponent implements OnInit {
  public flowOptions: WhatsappFlowOption[] = WHATSAPP_FLOW_OPTIONS;

  public eventTypeOptions = [
    { value: '', label: 'Todos' },
    { value: 'flow_started', label: 'Iniciado' },
    { value: 'flow_completed', label: 'Completado' },
  ];

  public selectedFlowToken: string = '';
  public selectedEventType: string = '';
  public dateFrom: Date | null = null;
  public dateTo: Date | null = null;

  public listEvents: EventLogItem[] = [];
  public totalItems: number = 0;
  public pageIndex: number = 1;
  public pageSize: number = 20;
  public loading: boolean = false;

  displayedColumns: string[] = [
    'createdAt',
    'flow',
    'status',
    'number',
    'programName',
    'result',
  ];

  constructor(private eventsService: EventsService) {}

  ngOnInit(): void {
    this.search();
  }

  search(): void {
    this.loading = true;
    this.eventsService
      .getRecentEvents({
        eventType: this.selectedEventType || 'flow_started,flow_completed',
        flowToken: this.selectedFlowToken || undefined,
        from: this.dateFrom ? this.dateFrom.toISOString() : undefined,
        to: this.dateTo ? this.dateTo.toISOString() : undefined,
        page: this.pageIndex,
        limit: this.pageSize,
      })
      .subscribe({
        next: (resp) => {
          this.listEvents = resp.data || [];
          this.totalItems = resp.total || 0;
          this.loading = false;
        },
        error: () => {
          this.listEvents = [];
          this.totalItems = 0;
          this.loading = false;
        },
      });
  }

  applyFilters(): void {
    this.pageIndex = 1;
    this.search();
  }

  clearFilters(): void {
    this.selectedFlowToken = '';
    this.selectedEventType = '';
    this.dateFrom = null;
    this.dateTo = null;
    this.pageIndex = 1;
    this.search();
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.search();
  }

  flowLabel(token: string | undefined): string {
    if (!token) return '—';
    return this.flowOptions.find((f) => f.token === token)?.label || token;
  }

  /** Extrae `metadata.token_flow` de forma segura para el template (evita el error TS4111). */
  flowTokenOf(event: EventLogItem): string | undefined {
    return event.metadata?.['token_flow'];
  }

  /** true si el evento es un flow_completed con error (metadata.ok === false). */
  isFailed(event: EventLogItem): boolean {
    return event.eventType === 'flow_completed' && event.metadata?.['ok'] === false;
  }

  /** true si el evento es un flow_completed exitoso. */
  isSucceeded(event: EventLogItem): boolean {
    return event.eventType === 'flow_completed' && event.metadata?.['ok'] !== false;
  }

  /** Resume el resultado guardado en metadata según el tipo de flow, para mostrarlo en la tabla. */
  resultSummary(event: EventLogItem): string {
    const meta = event.metadata || {};
    if (event.eventType !== 'flow_completed') {
      return '—';
    }
    if (meta['ok'] === false) {
      return `❌ ${meta['error'] || 'Error'}`;
    }
    switch (meta['token_flow']) {
      case 'CIMA_TOKEN':
        return `Score ${meta['score'] ?? '—'}`;
      case 'STRIVE_CO_TOKEN':
        return `Cuota ${meta['cuota'] ?? '—'} / Plazo ${meta['plazo'] ?? '—'}`;
      case 'PRICE_CO_TOKEN':
        return `Precio sugerido ${meta['suggestedPrice'] ?? '—'}`;
      default:
        return '✅ Completado';
    }
  }
}
